const ContainerLoader = () => <raul-container-loader />;

export default ContainerLoader;
